module.exports = __webpack_public_path__ + "img/All Survivors Pack.2c316c33.jpg";